import { Avatar, Button, Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import ProfilePic from "../../../../Asssets/Images/profile.png";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../../../Utils/Loader";
import { useStyle } from "../LeaveManagement/leaveStyles";
import { MdOutlineWatchLater } from "react-icons/md";
import { SiRocketdotchat } from "react-icons/si";
import { indivisualLoanRequestDetail } from "../../../../Redux/Actions/LoanRequests";
import moment from "moment";
import styles from "../RequestModule/RequestDetails.module.css";
import { BaseURL } from "../../../../Utils/interceptors";
import { getToken } from "../../../../Utils/helper";
import axios from "axios";
import { toast } from "react-toastify";
import Header from "../../../../Components/Header/Header";
import LoanPaymentHistory from "./LoanPaymentHistory";
import LoanPaymentHrActions from "./LoanPaymentHrActions";
import LoanSummaryCard from "./LoanSummaryCard";
import ApproveLoanModal from "./ApproveLoanModal";
import { formatIssueDateDisplay } from "./loanRequestUtils";

const formatRs = (value) =>
  `Rs ${Number(value || 0).toLocaleString("en-PK", { maximumFractionDigits: 2 })}`;

const LoanRequestDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyle();
  const [comment, setComment] = useState("");
  const [commentLoading, setCommentLoading] = useState(false);
  const { loading, loan } = useSelector((state) => state.loanRequestDetails);
  const { user } = useSelector((state) => state.currentUser);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const { id } = useParams();

  const isHr =
    user?.user?.role === "HR" || user?.user?.role === "admin";

  useEffect(() => {
    dispatch(indivisualLoanRequestDetail(id));
  }, [id, dispatch]);

  const refreshLoan = () => {
    dispatch(indivisualLoanRequestDetail(id));
  };

  const space = loan?.requested_by?.full_name?.indexOf(" ") ?? -1;
  const firstname =
    space > 0
      ? loan?.requested_by?.full_name?.substring(0, space)
      : loan?.requested_by?.full_name;

  const apiOptions = () => ({
    headers: {
      "Content-Type": "application/json",
      ...(getToken() && { Authorization: `Bearer ${getToken()}` }),
    },
  });

  const updateHandler = async (status, approvalData) => {
    const url = `${BaseURL}/loan-requests/confirmation/${loan?._id}`;
    try {
      setUpdateLoading(true);
      const body = { status };
      if (status === "approved" && approvalData) {
        body.issue_date = approvalData.issueDate;
        body.service_charge = approvalData.serviceCharge ?? 0;
      }
      const res = await axios.put(url, body, apiOptions());
      if (res) {
        toast.success(res?.data?.message);
        setShowApproveModal(false);
        if (status === "rejected") {
          navigate(-1);
        } else {
          refreshLoan();
        }
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to update status");
    } finally {
      setUpdateLoading(false);
    }
  };

  const handleSendComment = async () => {
    if (!comment.trim()) {
      return;
    }
    const url = `${BaseURL}/loan-requests/comment/${loan?._id}`;
    try {
      setCommentLoading(true);
      const res = await axios.put(url, { comment }, apiOptions());
      if (res) {
        toast.success(res?.data?.message);
        setComment("");
        refreshLoan();
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to send comment");
    } finally {
      setCommentLoading(false);
    }
  };

  return (
    <div className="page_responsive">
      <Header title="Loan Request Details" />
      {loading ? (
        <Loader />
      ) : (
        <div>
          <ApproveLoanModal
            open={showApproveModal}
            setOpen={setShowApproveModal}
            loading={updateLoading}
            initialServiceCharge={loan?.service_charge}
            onConfirm={(data) => updateHandler("approved", data)}
          />
          <LoanPaymentHrActions
            loan={loan}
            isHr={isHr}
            onUpdated={refreshLoan}
          />
          <Row className="align-items-stretch">
            <Col md={7} className="d-flex">
              <Box
                className="my-2 ms-4 w-100"
                sx={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <Paper
                  className={classes.sectionsContainer}
                  sx={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                  }}
                >
                  <Box className={classes.sectionHeader}>
                    {firstname} Loan Request
                  </Box>
                  <Box className="mx-3">
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                      className="my-3"
                    >
                      <div
                        className="d-flex align-items-center"
                        style={{ gap: "10px" }}
                      >
                        <Avatar
                          sx={{ width: "50px", height: "50px" }}
                          src={
                            loan?.requested_by?.profile_picture?.[0]
                              ?.fileName || ProfilePic
                          }
                        />
                        <Typography
                          variant="h6"
                          sx={{
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "#253766",
                          }}
                        >
                          {loan?.requested_by?.full_name}
                        </Typography>
                      </div>
                      <div className="created_at_container">
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <MdOutlineWatchLater
                            style={{
                              fontSize: "23px",
                              marginRight: "3px",
                              color: "#0097d9",
                            }}
                          />
                          <div>
                            <h6
                              className="mb-1"
                              style={{ color: "#0097d9", fontWeight: "500" }}
                            >
                              Applied On
                            </h6>
                            <h6 style={{ fontSize: "14px" }}>
                              {moment(loan?.applied_date).format("DD-MM-YYYY")}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </Box>
                  </Box>
                  <Box className={`mx-3 ${classes.leaveDetails}`}>
                    <Row className="mt-4 mb-2">
                      <Col md={4}>
                        <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                          Loan Amount
                        </Typography>
                      </Col>
                      <Col md={8}>
                        <Typography>{formatRs(loan?.amount)}</Typography>
                      </Col>
                    </Row>
                    <Row className="my-2">
                      <Col md={4}>
                        <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                          Description
                        </Typography>
                      </Col>
                      <Col md={8}>
                        <Typography sx={{ whiteSpace: "pre-wrap" }}>
                          {loan?.description?.trim()
                            ? loan.description
                            : "—"}
                        </Typography>
                      </Col>
                    </Row>
                    <Row className="my-2">
                      <Col md={4}>
                        <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                          Issue Date
                        </Typography>
                      </Col>
                      <Col md={8}>
                        <Typography>
                          {formatIssueDateDisplay(
                            loan?.issue_date,
                            loan?.hr_status,
                          )}
                        </Typography>
                      </Col>
                    </Row>
                    <Row className="my-2">
                      <Col md={4}>
                        <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                          Status
                        </Typography>
                      </Col>
                      <Col md={8}>
                        <Box
                          className={
                            loan?.hr_status === "pending"
                              ? classes.pending
                              : loan?.hr_status === "approved"
                                ? classes.approved
                                : classes.rejected
                          }
                        >
                          {loan?.hr_status}
                        </Box>
                      </Col>
                    </Row>
                    {isHr && loan?.hr_status === "pending" && (
                      <Col md={12}>
                        <div className={styles.btn__wrapper}>
                          <Button
                            onClick={() => setShowApproveModal(true)}
                            variant="contained"
                            className={classes.approvedBtn}
                          >
                            {updateLoading ? (
                              <Spinner animation="border" size="sm" />
                            ) : (
                              "Approve"
                            )}
                          </Button>
                          <Button
                            onClick={() => updateHandler("rejected")}
                            variant="contained"
                            className={classes.rejectedBtn}
                          >
                            {updateLoading ? (
                              <Spinner animation="border" size="sm" />
                            ) : (
                              "Reject"
                            )}
                          </Button>
                        </div>
                      </Col>
                    )}
                  </Box>
                  <Box sx={{ flex: 1, minHeight: 0 }} aria-hidden />
                </Paper>
              </Box>
            </Col>
            <Col md={5} className="d-flex">
              <Box
                className="my-2 me-4 w-100"
                sx={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <LoanSummaryCard loan={loan} />
              </Box>
            </Col>
          </Row>

          <LoanPaymentHistory
            loan={loan}
            isHr={isHr}
            onUpdated={refreshLoan}
          />

          <Row>
            <Col md={12}>
              <Box className="my-2 mx-4">
                <Paper className={classes.sectionsContainer}>
                  <Box className={classes.sectionHeader}>
                    <SiRocketdotchat /> Chat
                  </Box>
                  <Box sx={{ p: 2 }}>
                    {loan?.conversation?.length ? (
                      loan.conversation.map((d, idx) => (
                        <Box
                          key={idx}
                          sx={{ pb: 2, display: "flex", gap: "10px" }}
                        >
                          <Avatar
                            sx={{ width: "55px", height: "55px" }}
                            src={d?.user?.profile_picture?.[0]?.fileName}
                          />
                          <Box sx={{ width: "100%" }}>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mb: 1,
                              }}
                            >
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "600",
                                  fontSize: "16px",
                                  color: "#253766",
                                }}
                              >
                                {d?.user?.full_name}
                              </Typography>
                              <Typography
                                sx={{ fontWeight: "500", fontSize: "14px" }}
                              >
                                {new Date(d?.created).toLocaleString()}
                              </Typography>
                            </Box>
                            <Typography
                              sx={{
                                fontWeight: "500",
                                fontSize: "14px",
                                backgroundColor: "#ebf4f7",
                                padding: "10px",
                              }}
                            >
                              {d?.comment}
                            </Typography>
                          </Box>
                        </Box>
                      ))
                    ) : (
                      <Typography variant="h6" className="mt-3">
                        No previous comments found!
                      </Typography>
                    )}
                  </Box>
                  <Box sx={{ p: 2 }}>
                    <Box sx={{ position: "relative" }}>
                      <input
                        placeholder="Type a message"
                        style={{
                          width: "100%",
                          padding: "20px 110px 40px 20px",
                          border: "1px solid #d6eff7",
                        }}
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                      />
                      <button
                        type="button"
                        style={{
                          position: "absolute",
                          right: "20px",
                          top: "26%",
                        }}
                        className={classes.sendBtn}
                        onClick={handleSendComment}
                        disabled={commentLoading}
                      >
                        {commentLoading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          "Send"
                        )}
                      </button>
                    </Box>
                  </Box>
                </Paper>
              </Box>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};

export default LoanRequestDetails;
